import Bugsnag from '@bugsnag/js'
import { Box, Typography } from '@mui/material'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import EmployeeList from 'module/payroll/global-components/EmployeeList'
import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { removeExcludedEmployee } from 'services/api/modules/payroll/payroll-config/excludeEmployeeApi'

const ExcludedEmployeeList = ({ data, sx }) => {
  const { name, avatar, position, department, employee_id } = data

  const [isModalOpen, setModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const handleClose = () => {
    setModalOpen(false)
  }

  const queryClient = useQueryClient()
  const { mutate } = useMutation((val) => removeExcludedEmployee(val), {
    onSuccess: () => {
      setIsLoading(false)
      setModalOpen(false)
      queryClient.invalidateQueries('getExcludedEmployees')
      queryClient.invalidateQueries('getAllAvailableEmployees')
    },
    onError: (error) => {
      setIsLoading(false)
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })
  const handleRemove = () => {
    setIsLoading(true)
    mutate(employee_id)
  }
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: 2, ...sx }}>
      <Box sx={{ width: 'calc(100% * 2 / 5)' }}>
        <EmployeeList avatar={avatar} name={name} position={position} />
      </Box>
      <Box sx={{ width: 'calc(100% * 2 / 5)' }}>
        <Typography color="light-gray-text.main">{department}</Typography>
      </Box>
      <Box sx={{ width: 'calc(100% * 1 / 5)' }} textAlign="right">
        <Typography
          sx={{ cursor: 'pointer', textDecoration: 'underline' }}
          variant="subtitle1"
          color="error.main"
          onClick={() => setModalOpen(true)}
        >
          Remove
        </Typography>
      </Box>
      <AdxInfoModal
        variant={'error'}
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        title="Are you sure?"
        subtitle={`${name} will no longer be excluded during payroll run`}
        footerButtons
        firstBtnLabel={'Remove'}
        firstBtnHandle={handleRemove}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      ></AdxInfoModal>
    </Box>
  )
}

export default ExcludedEmployeeList
